<template>
    <div>
            [Budget]
    </div>
</template>

<script>

    import { ref } from 'vue'
    import { useStore } from 'vuex'

    import Form from '@/components/Form.vue'
    import Icon from '@/components/Icon.vue'
    import Field from '@/components/Field.vue'

    export default {
      name: 'Budget',
      components: {
          Form,
          Field,
          Icon
      },
      created(){          
            document.title="Budget";
      },
      setup(){

          let store = useStore();

        return{
            store
        }    
      }
    }
</script>
